export default __webpack_public_path__ + "static/media/greenplanet.80664770.svg";